import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Common.css';

function Subscriptions({ apiBase }) {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    loadSubscriptions();
  }, []);

  const loadSubscriptions = async (page = 1) => {
    try {
      setLoading(true);
      let url = `${apiBase}/api/admin/subscriptions?page=${page}&limit=20`;
      if (status) url += `&status=${status}`;

      const response = await axios.get(url);
      if (response.data.success) {
        setSubscriptions(response.data.data);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.error('Error loading subscriptions:', error);
    } finally {
      setLoading(false);
    }
  };

  const getBadgeClass = (paymentStatus, isActive, daysRemaining) => {
    if (paymentStatus === 'active' && isActive && daysRemaining > 0) {
      return 'badge badge-success';
    } else if (paymentStatus === 'expired' || daysRemaining <= 0) {
      return 'badge badge-danger';
    } else {
      return 'badge badge-warning';
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-KE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="component-container">
      <div className="filter-bar">
        <select 
          value={status} 
          onChange={(e) => setStatus(e.target.value)}
          className="filter-select"
        >
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="expired">Expired</option>
        </select>

        <button onClick={() => loadSubscriptions()} className="btn btn-primary">
          Apply Filters
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading subscriptions...</div>
      ) : (
        <>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Phone</th>
                  <th>Package</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Days Left</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="empty-state">No subscriptions found</td>
                  </tr>
                ) : (
                  subscriptions.map((subscription) => (
                    <tr key={subscription.id}>
                      <td>#{subscription.id}</td>
                      <td>{subscription.user_phone}</td>
                      <td>{subscription.package_name}</td>
                      <td>KES {parseFloat(subscription.price).toFixed(2)}</td>
                      <td>
                        <span className={getBadgeClass(
                          subscription.payment_status, 
                          subscription.is_active, 
                          subscription.days_remaining
                        )}>
                          {subscription.payment_status}
                        </span>
                      </td>
                      <td>
                        {subscription.days_remaining > 0 
                          ? `${subscription.days_remaining} days` 
                          : 'Expired'}
                      </td>
                      <td>{formatDate(subscription.start_date)}</td>
                      <td>{formatDate(subscription.end_date)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {pagination && pagination.pages > 1 && (
            <div className="pagination">
              <button 
                onClick={() => loadSubscriptions(pagination.page - 1)}
                disabled={pagination.page === 1}
                className="btn"
              >
                Previous
              </button>
              <span>Page {pagination.page} of {pagination.pages}</span>
              <button 
                onClick={() => loadSubscriptions(pagination.page + 1)}
                disabled={pagination.page === pagination.pages}
                className="btn"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Subscriptions;
